import { render, staticRenderFns } from "./CRD10000.vue?vue&type=template&id=22f54c40&"
import script from "./CRD10000.vue?vue&type=script&lang=js&"
export * from "./CRD10000.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports